<template>
    <div class="footer">
        <div>
            <p>Copyright © 2017 龙源数字传媒集团 京ICP备10216796号-6</p>
            <p>Dragonsource.com Inc.All Rights Reserved</p>
            <p>IP:{{userIp}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            userIp(){              
                return this.$store.state.userIp;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .footer{
       width: 100%;
       height: 100%;
       position: relative;
       div{
           position:absolute;
           width: 400px;
           left:calc(50% - 200px);
           font-size: 14px;
           top: 30px;
           color: #adadad;
           p{
                height: 25px;
                line-height: 25px;
                width: inherit;
                text-align: center;
           }
       }
    }
</style>
